import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const useServerStatus = () => {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/server/status");
        if (alive) setStatus(data);
      } catch (e) {
        if (alive) setStatus({ online: false, players: 0, max_players: 64 });
      }
    };
    load();
    const id = setInterval(load, 30000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return status;
};

export const ServerStatus = ({ className = "" }) => {
  const status = useServerStatus();
  const online = status?.online;
  const label = status === null ? "CHECKING" : online ? "ONLINE" : "OFFLINE";
  const dot = status === null ? "bg-[#8F877C]" : online ? "bg-teal" : "bg-destructive";
  return (
    <div
      data-testid="server-status-badge"
      className={`inline-flex items-center gap-3 font-mono text-xs sm:text-sm uppercase tracking-widest border px-4 py-2 ${online ? "border-teal/30 bg-teal/10 text-teal" : "border-[#2A201A] bg-surface/60 text-[#8F877C]"} ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className={`absolute inline-flex h-full w-full rounded-full ${dot} ${online ? "animate-ping opacity-75" : ""}`} />
        <span className={`relative inline-flex h-2 w-2 rounded-full ${dot}`} />
      </span>
      <span>{label}</span>
      <span className="text-bone">
        {status?.players ?? 0}<span className="text-[#8F877C]">/{status?.max_players ?? 64}</span>
      </span>
    </div>
  );
};
